import { useState, useEffect } from 'react';
import { isMobile } from 'utils/generalUtils';

export const useMobileState = ({ mobileScreenWidth }: { mobileScreenWidth?: number } = {}) => {
  const [isMobileScreen, setIsMobileScreen] = useState(isMobile());
  const [isExpanded, setIsExpanded] = useState(false);

  // Handle window resize to update mobile state
  useEffect(() => {
    const handleResize = () => {
      setIsMobileScreen(isMobile(mobileScreenWidth));
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Lock body scroll when mobile navigation is expanded
  useEffect(() => {
    if (isMobileScreen && isExpanded) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    // Cleanup on unmount
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMobileScreen, isExpanded]);

  const handleToggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  const handleCloseNavigation = () => {
    setIsExpanded(false);
  };

  return {
    isMobileScreen,
    isExpanded,
    handleToggleExpanded,
    handleCloseNavigation,
  };
};
